import EqList from "./components/List"
import EqForm from "./components/Form"

let module = "equipments"

export default [
  { path: "equipments", component: EqList, meta: { module: module, permissions: ["equipment-access"] } },
  {
    path: "equipments/create",
    component: EqForm,
    props: true,
    meta: { module: module, permissions: ["equipment-access"] }
  },
  {
    path: "equipments/edit/:id",
    component: EqForm,
    props: true,
    meta: { module: module, permissions: ["equipment-access"] }
  },
]
